// Veercal design tokens, v2 ("Tell-tale"). JS mirror of public/design/v2/tokens.css.
// Hand-synced: change both together. tokens-sync.test.js fails if they drift.
// Rules for using them: docs/brand/DESIGN.md.

export const tokensV2 = {
  cabin: '#F2F0EB',
  surface: '#FFFFFF',
  tint: '#E4E0D8',
  ink: '#16181B',

  line: '#D6D1C7',
  lineStrong: '#8F8A80',

  text: '#16181B',
  textSecondary: '#4A4D52',
  textOnInk: '#F2F0EB',
  textOnInkSecondary: '#C9C6BF',

  amber: '#E89B0C',
  amberText: '#8A5300',
  green: '#17784A',
  red: '#C22B24',
  blue: '#2457C5',

  font: "'Barlow', system-ui, -apple-system, 'Segoe UI', sans-serif",
  fw: { body: 500, label: 600, head: 700 },

  gauge: { width: 14, height: 56, gap: 3, meterUnlitOpacity: 0.12 },
};

// CSS custom property name for each key above (used by the sync test).
export const cssVarNames = {
  cabin: '--vc-cabin',
  surface: '--vc-surface',
  tint: '--vc-tint',
  ink: '--vc-ink',
  line: '--vc-line',
  lineStrong: '--vc-line-strong',
  text: '--vc-text',
  textSecondary: '--vc-text-secondary',
  textOnInk: '--vc-text-on-ink',
  textOnInkSecondary: '--vc-text-on-ink-secondary',
  amber: '--vc-amber',
  amberText: '--vc-amber-text',
  green: '--vc-green',
  red: '--vc-red',
  blue: '--vc-blue',
};
